export default __webpack_public_path__ + "static/media/AUSFINTECH.06c86f39.png";